import { Button } from '../../../common/Button';
import { Spinner } from '../../../components/Spinner';
import { useAuth } from '../../../contexts/AuthContext';

import { useDisconnectSlack } from './hooks/useDisconnectSlack';
import { useGetSlackConnectionStatus } from './hooks/useGetSlackConnection';

export function SlackIntegration(): JSX.Element {
  const { userData } = useAuth();
  const {
    error,
    isLoading,
    data: isConnected,
  } = useGetSlackConnectionStatus(userData?.id);
  const CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID;
  const REDIRECT_URI = `${window.location.origin}/auth/slack/callback`;
  const SCOPES = 'users:read,team:read';

  const { mutate: disconnectSlack } = useDisconnectSlack();

  const handleConnectSlack = (): void => {
    if (!CLIENT_ID) return;
    const slackAuthUrl = `https://slack.com/oauth/v2/authorize?client_id=${CLIENT_ID}&scope=${SCOPES}&redirect_uri=${REDIRECT_URI}`;
    window.location.href = slackAuthUrl;
  };

  const handleDisconnectSlack = (): void => {
    if (!userData?.id) return;
    disconnectSlack({ userId: userData.id });
  };

  return (
    <div className="flex flex-col gap-2 items-start justify-center w-full bg-surface-0 p-6 rounded-lg border border-border-gray ">
      <h3 className="text-xl font-semibold mb-2 w-full">Slack</h3>
      {error && <p className="text-error">{error.message}</p>}
      {isLoading && <Spinner />}
      {!isLoading && isConnected ? (
        <div>
          <p className="mb-2">Your Slack is connected.</p>
          <Button onClick={handleDisconnectSlack} variant="secondary" size="md">
            Disconnect Slack
          </Button>
        </div>
      ) : (
        <div className="flex flex-col gap-2 items-start justify-center w-full">
          <p>Connect your Slack to sync your meetings.</p>
          <Button onClick={handleConnectSlack} variant="primary" size="md">
            Connect Slack
          </Button>
        </div>
      )}
    </div>
  );
}

export default SlackIntegration;
